const parseJsonWithTrailingBrackets = (value) => {
  const trimmedValue = value.trim();

  try {
    return JSON.parse(trimmedValue);
  } catch {
    let candidate = trimmedValue;

    while (candidate.endsWith("]")) {
      candidate = candidate.slice(0, -1).trimEnd();

      try {
        return JSON.parse(candidate);
      } catch {
        continue;
      }
    }

    return [];
  }
};

export const normalizeNpsReport = (report) => {
  if (Array.isArray(report)) {
    return report;
  }

  if (typeof report !== "string") {
    return [];
  }

  const parsedReport = parseJsonWithTrailingBrackets(report);

  if (Array.isArray(parsedReport)) {
    return parsedReport;
  }

  if (parsedReport && typeof parsedReport === "object") {
    return [parsedReport];
  }

  return [];
};
